import { FormField, FormFieldSelect } from 'global/components/Form'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { faixaColaborador } from 'service/api'

interface Props {
    limiteFuncionarios?: number
    disabled?: boolean
    required?: boolean
}

export function SelectColaboradores({
    disabled,
    required,
    limiteFuncionarios: limiteDefault,
}: Props) {
    const { setValue, watch } = useFormContext()
    const [data, setData] = useState<number[]>([])

    useEffect(() => {
        if (!data.length)
            faixaColaborador
                .get()
                .then(res => setData(res ?? []))
                .catch(() => setData([]))
    }, [data])

    const faixa = watch('limiteFuncionarios')

    useEffect(() => {
        if (!faixa && data?.length && limiteDefault)
            setValue('limiteFuncionarios', limiteDefault)
    }, [data])

    if (!data?.length) {
        return (
            <FormField
                name="limiteFuncionarios"
                label="Faixa de Colaboradores"
                disabled
            />
        )
    }

    const opcoes = [
        ...data
            .sort((a, b) => a - b)
            .map(limite => ({ value: limite, label: `até ${limite}` })),
        ...(faixa && !data.includes(faixa)
            ? [{ value: faixa, label: `Especial (até ${faixa})` }]
            : []),
    ]

    return (
        <FormFieldSelect
            name="limiteFuncionarios"
            label="Faixa de Colaboradores"
            disabled={disabled}
            required={required}
            options={opcoes}
        />
    )
}
